// Import test kit images
import beforeYouGoImage from '../../assets/before-you-go-image-1.webp';
import covidAg from '../../assets/covid-ag.webp';
import covidTestKit2 from '../../assets/covid-test-kit2.webp';

export const covidTestKitsSpecifications = [
    {
        heading: "Home Test",
        description: "If a Digital Health Pass is not necessary, or there is a tight budget, this Abbott BinaxNOW™ COVID-19 Rapid Antigen Self Test is ideal. It is an at-home solution authorized for non-prescription home use with self-collected direct anterior nasal (nares) swab samples from individuals 15 years or older, or 2 years or older only if samples are collected by an adult.",
        features: [
            "Results reporting in 15 minutes",
            "Test sensitivity of 84.6% and specificity of 98.5%",
            "2 tests in each box",
            "No need to send results to a lab",
            "Prescription is not needed"
        ],
        image: beforeYouGoImage,
        imageAlt: "Home Test"
    },
    {
        heading: "Home Test with Digital Health Pass",
        description: "Abbott BinaxNOW™ COVID-19 Ag Card Home Test, Enabled by eMed, utilizes a digital platform to virtually guide the user through the test process from beginning to end. The test delivers results in just 15 minutes with no instrumentation, using proven lateral flow technology. NAVICA, Abbott's complementary smartphone app, provides a Digital Health Pass with BinaxNOW test results to show where people gather such as workplaces, schools, events, and when traveling.",
        features: [
            "Results reporting in 15 minutes",
            "Test sensitivity of 97.1% and specificity of 98.5%",
            "Third-party verification ensures authentication",
            "Digital Health Results sent to mobile app with Digital Health Pass or Guide To Care Instructions",
            "24/7 Live Support – eMed certified guides & customer support agents"
        ],
        image: covidTestKit2,
        imageAlt: "Home Test with Digital Health Pass"
    },
    {
        heading: "Onsite Test",
        description: "This Abbott BinaxNow™ COVID-19 Ag Card Test is perfect for larger gatherings, such as those returning to workplaces, conferences, and professional sporting events. It is a rapid antigen test (not a PCR test), and is authorized for use in settings operating under a CLIA Certificate. Tests should be administered by a medical professional or trained administrator. Packaging images may vary.",
        features: [
            "Results reporting in 15 minutes",
            "Test sensitivity of 97.1% and specificity of 98.5%",
            "40 tests in each box, 1 reagent vial per box",
            "No need to send results to a lab",
            "Prescription is not needed"
        ],
        image: covidAg,
        imageAlt: "Onsite Test"
    }
]; 